import ReviewsGrid from './reviews-grid'
export default ReviewsGrid
